"use client"

import { VendorDetailLayoutSkeleton } from './loading';

export function VendorPageSkeleton() {
  return <VendorDetailLayoutSkeleton />;
}